import React, { memo, useMemo } from "react";

const Menu = ({ userType }) => {
  const columns = useMemo(() => {
    const baseColumns = [
      "Acc-Number",
      "Acc-Name",
      "Acc-Ifsc",
      "Acc-Type",
      "Bank-Name",
      "Upi Id",
      "Qr-Name",
      "Date",
      "ACTION",
    ];

    if (userType === 1) {
      // For admin: add both Super, Master, and one extra empty column
      return ["Super", "Master", ...baseColumns];
    } else if (userType === 2) {
      // For super: add Master only
      return ["Master", ...baseColumns];
    } else {
      // For others (master, broker, user)
      return [...baseColumns];
    }
  }, [userType]);

  return (
    <div className="menuContainer primary white">
      {columns.map((label, index) => (
        <div
          key={index}
          className={
            label === "Super" || label === "Master" || label === "Username"
              ? "menuUsername"
              : "menuName"
          }
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default memo(Menu);
